import { useCallback, useEffect } from 'react';
import { useAppDispatch } from '../store/configureStore';

import * as actions from '../store/connectivity';

const useConnectivity = (): void => {
	const dispatch = useAppDispatch();

	const handleInternetChange = useCallback((): void => {
		dispatch(actions.updateConnectionStatus());
	}, [dispatch]);

	const handleSyncRequests = useCallback((): void => {
		handleInternetChange();
		dispatch(actions.performSynchronization());
	}, [dispatch, handleInternetChange]);

	useEffect(() => {
		handleInternetChange();
	}, [handleInternetChange]);

	useEffect(() => {
		window.addEventListener('online', handleSyncRequests);
		window.addEventListener('offline', handleInternetChange);

		return () => {
			window.removeEventListener('online', handleSyncRequests);
			window.removeEventListener('offline', handleInternetChange);
		};

		// eslint-disable-next-line
	}, []);
};

export default useConnectivity;
